import type { NxChartTooltipRow } from './NxChartTooltip.vue';

/**
 * The spoken form of a chart tooltip: „März: Nord 120, Süd 80, Summe 200“.
 * Rows without a label (a single series) read as the bare value.
 */
export function announceTooltip(
  tip: { title?: string; rows?: readonly NxChartTooltipRow[]; footer?: string } | null
): string {
  if (!tip) return '';
  const values = (tip.rows ?? []).map((r) => (r.label ? `${r.label} ${r.value}` : r.value));
  if (tip.footer) values.push(tip.footer);
  const body = values.join(', ');
  return tip.title ? (body ? `${tip.title}: ${body}` : tip.title) : body;
}
